const ReferralFaqContent = [
  {
    title: "What is Lighter Advisory?",
    content:
      "Lighter Advisory is a real estate advisory primarily focused on creating a delightful customer experience. We walk with you through the entire journey of finding, exploring and buying or renting the perfect property as per your needs.",
  },

  {
    title: "Why Lighter Advisory?",
    content:
      "Lighter Advisory connects real estate clients by creating a powerful professional network.",
  },

  {
    title: "How does the Lighter Advisory referral reward program work?",
    content:
      "Lighter Advisory is a one of its kind program where you send us a lead, either a property requirement or a client requirement. We shall source the property or customer for your lead and close the deal. After the transaction, you will be earning your reward.",
  },

  {
    title: "When do I receive my reward?",
    content:
      "You will be receiving your reward within a week of the completion of the transaction.",
  },

  {
    title: "What is the rate of commission / What is my referral reward?",
    content:
      "Commission rate varies from 0.1% to 1% on the transaction value, depending on the deal.",
  },

  {
    title: "How do I receive my commission?",
    content:
      "You will be receiving your reward either by cheque or account transfer.",
  },

  {
    title:
      "What if I am not a resident of India? Will I still be a part of the referral program?",
    content:
      "Yes. You can be a part of the Lighter Advisory Referral Reward Program from anywhere in the world. Lighter Advisory will make sure you get your reward, regardless of which corner of the world you are in.",
  },
];

export default ReferralFaqContent;
